import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharSequence1ju9jr1w86plq as isCharSequence,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  trim11nh7r46at6sx as trim,
  startsWith1bgirhbedtv2y as startsWith,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from './serialization/Defaults.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { startsWith26w8qjqapeeq6 as startsWith_0 } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Char19o2r8palgjof as Char,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_emailRegex() {
  _init_properties_StringAlts_kt__fevqij();
  return emailRegex;
}
var emailRegex;
function get_punctuation() {
  _init_properties_StringAlts_kt__fevqij();
  return punctuation;
}
var punctuation;
var TrimOnSerializeClass;
function TrimOnSerialize() {
  if (TrimOnSerializeClass === VOID) {
    class $ {
      constructor() {
        TrimOnSerialize_instance = this;
        this.i3m_1 = PrimitiveSerialDescriptor('kotlin.String/TrimOnSerialize', STRING_getInstance());
      }
      pz(decoder) {
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.h13();
        return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      }
      az() {
        return this.i3m_1;
      }
      v1g(encoder, value) {
        return encoder.p14(value);
      }
      oz(encoder, value) {
        return this.v1g(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimOnSerialize', VOID, VOID, [KSerializer()]);
    TrimOnSerializeClass = $;
  }
  return TrimOnSerializeClass;
}
var TrimOnSerialize_instance;
function TrimOnSerialize_getInstance() {
  if (TrimOnSerialize_instance === VOID)
    new (TrimOnSerialize())();
  return TrimOnSerialize_instance;
}
var TrimLowercaseOnSerializeClass;
function TrimLowercaseOnSerialize() {
  if (TrimLowercaseOnSerializeClass === VOID) {
    class $ {
      constructor() {
        TrimLowercaseOnSerialize_instance = this;
        this.j3m_1 = PrimitiveSerialDescriptor('kotlin.String/TrimLowercaseOnSerialize', STRING_getInstance());
      }
      pz(decoder) {
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.h13();
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
      }
      az() {
        return this.j3m_1;
      }
      v1g(encoder, value) {
        return encoder.p14(value);
      }
      oz(encoder, value) {
        return this.v1g(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimLowercaseOnSerialize', VOID, VOID, [KSerializer()]);
    TrimLowercaseOnSerializeClass = $;
  }
  return TrimLowercaseOnSerializeClass;
}
var TrimLowercaseOnSerialize_instance;
function TrimLowercaseOnSerialize_getInstance() {
  if (TrimLowercaseOnSerialize_instance === VOID)
    new (TrimLowercaseOnSerialize())();
  return TrimLowercaseOnSerialize_instance;
}
var LowercaseOnSerializeClass;
function LowercaseOnSerialize() {
  if (LowercaseOnSerializeClass === VOID) {
    class $ {
      constructor() {
        LowercaseOnSerialize_instance = this;
        this.k3m_1 = PrimitiveSerialDescriptor('kotlin.String/LowercaseOnSerialize', STRING_getInstance());
      }
      pz(decoder) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        return decoder.h13().toLowerCase();
      }
      az() {
        return this.k3m_1;
      }
      v1g(encoder, value) {
        return encoder.p14(value);
      }
      oz(encoder, value) {
        return this.v1g(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LowercaseOnSerialize', VOID, VOID, [KSerializer()]);
    LowercaseOnSerializeClass = $;
  }
  return LowercaseOnSerializeClass;
}
var LowercaseOnSerialize_instance;
function LowercaseOnSerialize_getInstance() {
  if (LowercaseOnSerialize_instance === VOID)
    new (LowercaseOnSerialize())();
  return LowercaseOnSerialize_instance;
}
var TrimmedStringSerializerClass;
function TrimmedStringSerializer() {
  if (TrimmedStringSerializerClass === VOID) {
    class $ {
      constructor() {
        TrimmedStringSerializer_instance = this;
        this.l3m_1 = PrimitiveSerialDescriptor('com.lightningkite.TrimmedString', STRING_getInstance());
      }
      m3m(decoder) {
        // Inline function 'com.lightningkite.trimmed' call
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.h13();
        var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        return _TrimmedString___init__impl__orw15u(tmp$ret$0);
      }
      pz(decoder) {
        return new (TrimmedString())(this.m3m(decoder));
      }
      az() {
        return this.l3m_1;
      }
      n3m(encoder, value) {
        return encoder.p14(_TrimmedString___get_raw__impl__87z345(value));
      }
      oz(encoder, value) {
        return this.n3m(encoder, value instanceof TrimmedString() ? value.o3m_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimmedStringSerializer', VOID, VOID, [KSerializer()]);
    TrimmedStringSerializerClass = $;
  }
  return TrimmedStringSerializerClass;
}
var TrimmedStringSerializer_instance;
function TrimmedStringSerializer_getInstance() {
  if (TrimmedStringSerializer_instance === VOID)
    new (TrimmedStringSerializer())();
  return TrimmedStringSerializer_instance;
}
var TrimmedCaselessStringSerializerClass;
function TrimmedCaselessStringSerializer() {
  if (TrimmedCaselessStringSerializerClass === VOID) {
    class $ {
      constructor() {
        TrimmedCaselessStringSerializer_instance = this;
        this.p3m_1 = PrimitiveSerialDescriptor('com.lightningkite.TrimmedCaselessString', STRING_getInstance());
      }
      q3m(decoder) {
        // Inline function 'com.lightningkite.trimmedCaseless' call
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.h13();
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
        return _TrimmedCaselessString___init__impl__li6it1(tmp$ret$2);
      }
      pz(decoder) {
        return new (TrimmedCaselessString())(this.q3m(decoder));
      }
      az() {
        return this.p3m_1;
      }
      r3m(encoder, value) {
        return encoder.p14(_TrimmedCaselessString___get_raw__impl__ibsfwu(value));
      }
      oz(encoder, value) {
        return this.r3m(encoder, value instanceof TrimmedCaselessString() ? value.s3m_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimmedCaselessStringSerializer', VOID, VOID, [KSerializer()]);
    TrimmedCaselessStringSerializerClass = $;
  }
  return TrimmedCaselessStringSerializerClass;
}
var TrimmedCaselessStringSerializer_instance;
function TrimmedCaselessStringSerializer_getInstance() {
  if (TrimmedCaselessStringSerializer_instance === VOID)
    new (TrimmedCaselessStringSerializer())();
  return TrimmedCaselessStringSerializer_instance;
}
var CaselessStringSerializerClass;
function CaselessStringSerializer() {
  if (CaselessStringSerializerClass === VOID) {
    class $ {
      constructor() {
        CaselessStringSerializer_instance = this;
        this.t3m_1 = PrimitiveSerialDescriptor('com.lightningkite.CaselessString', STRING_getInstance());
      }
      u3m(decoder) {
        // Inline function 'com.lightningkite.caseless' call
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = decoder.h13().toLowerCase();
        return _CaselessString___init__impl__ihury1(tmp$ret$1);
      }
      pz(decoder) {
        return new (CaselessString())(this.u3m(decoder));
      }
      az() {
        return this.t3m_1;
      }
      v3m(encoder, value) {
        return encoder.p14(_CaselessString___get_raw__impl__xzssfw(value));
      }
      oz(encoder, value) {
        return this.v3m(encoder, value instanceof CaselessString() ? value.w3m_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'CaselessStringSerializer', VOID, VOID, [KSerializer()]);
    CaselessStringSerializerClass = $;
  }
  return CaselessStringSerializerClass;
}
var CaselessStringSerializer_instance;
function CaselessStringSerializer_getInstance() {
  if (CaselessStringSerializer_instance === VOID)
    new (CaselessStringSerializer())();
  return CaselessStringSerializer_instance;
}
var EmailAddressSerializerClass;
function EmailAddressSerializer() {
  if (EmailAddressSerializerClass === VOID) {
    class $ {
      constructor() {
        EmailAddressSerializer_instance = this;
        this.x3m_1 = PrimitiveSerialDescriptor('com.lightningkite.EmailAddress', STRING_getInstance());
      }
      y3m() {
        return toEmailAddress('example@example.com');
      }
      z3m() {
        return new (EmailAddress())(this.y3m());
      }
      a3n(decoder) {
        return toEmailAddress(decoder.h13());
      }
      pz(decoder) {
        return new (EmailAddress())(this.a3n(decoder));
      }
      az() {
        return this.x3m_1;
      }
      b3n(encoder, value) {
        return encoder.p14(_EmailAddress___get_raw__impl__6ose2(value));
      }
      oz(encoder, value) {
        return this.b3n(encoder, value instanceof EmailAddress() ? value.c3n_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'EmailAddressSerializer', VOID, VOID, [KSerializerWithDefault()]);
    EmailAddressSerializerClass = $;
  }
  return EmailAddressSerializerClass;
}
var EmailAddressSerializer_instance;
function EmailAddressSerializer_getInstance() {
  if (EmailAddressSerializer_instance === VOID)
    new (EmailAddressSerializer())();
  return EmailAddressSerializer_instance;
}
var PhoneNumberSerializerClass;
function PhoneNumberSerializer() {
  if (PhoneNumberSerializerClass === VOID) {
    class $ {
      constructor() {
        PhoneNumberSerializer_instance = this;
        this.d3n_1 = PrimitiveSerialDescriptor('com.lightningkite.PhoneNumber', STRING_getInstance());
      }
      e3n() {
        return _PhoneNumber___init__impl__slwhzy('+18000000000');
      }
      z3m() {
        return new (PhoneNumber())(this.e3n());
      }
      f3n(decoder) {
        return toPhoneNumber(decoder.h13());
      }
      pz(decoder) {
        return new (PhoneNumber())(this.f3n(decoder));
      }
      az() {
        return this.d3n_1;
      }
      g3n(encoder, value) {
        return encoder.p14(_PhoneNumber___get_raw__impl__gc2pmp(value));
      }
      oz(encoder, value) {
        return this.g3n(encoder, value instanceof PhoneNumber() ? value.h3n_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PhoneNumberSerializer', VOID, VOID, [KSerializer(), KSerializerWithDefault()]);
    PhoneNumberSerializerClass = $;
  }
  return PhoneNumberSerializerClass;
}
var PhoneNumberSerializer_instance;
function PhoneNumberSerializer_getInstance() {
  if (PhoneNumberSerializer_instance === VOID)
    new (PhoneNumberSerializer())();
  return PhoneNumberSerializer_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i3n_1 = setOf(['com.lightningkite.TrimmedString', 'com.lightningkite.CaselessString', 'com.lightningkite.TrimmedCaselessString', 'com.lightningkite.EmailAddress', 'com.lightningkite.PhoneNumber']);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function compareTo_0(other) {
  return compareTo(this.j3n(), other.j3n());
}
var IsRawStringClass;
function IsRawString() {
  if (IsRawStringClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'IsRawString', VOID, VOID, [Comparable()]);
    IsRawStringClass = $;
  }
  return IsRawStringClass;
}
function _TrimmedString___init__impl__orw15u(raw) {
  return raw;
}
function _TrimmedString___get_raw__impl__87z345($this) {
  return $this;
}
function TrimmedString__toString_impl_1ysh22($this) {
  return _TrimmedString___get_raw__impl__87z345($this);
}
function TrimmedString__mapRaw_impl_a1khly($this, action) {
  // Inline function 'kotlin.let' call
  // Inline function 'com.lightningkite.trimmed' call
  // Inline function 'kotlin.text.trim' call
  var this_0 = action(_TrimmedString___get_raw__impl__87z345($this));
  var tmp$ret$1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  return _TrimmedString___init__impl__orw15u(tmp$ret$1);
}
function TrimmedString__mapRaw_impl_a1khly_0($this, action) {
  return new (TrimmedString())(TrimmedString__mapRaw_impl_a1khly($this.o3m_1, action));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      m2a() {
        return TrimmedStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function TrimmedString__hashCode_impl_npydux($this) {
  return getStringHashCode($this);
}
function TrimmedString__equals_impl_11kln1($this, other) {
  if (!(other instanceof TrimmedString()))
    return false;
  if (!($this === other.o3m_1))
    return false;
  return true;
}
function TrimmedString__compareTo_impl_v1jip4($this, other) {
  return $this.l3n((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var TrimmedStringClass;
function TrimmedString() {
  if (TrimmedStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.o3m_1 = raw;
      }
      j3n() {
        return _TrimmedString___get_raw__impl__87z345(this.o3m_1);
      }
      toString() {
        return TrimmedString__toString_impl_1ysh22(this.o3m_1);
      }
      m3n(action) {
        return TrimmedString__mapRaw_impl_a1khly(this.o3m_1, action);
      }
      k3n(action) {
        return TrimmedString__mapRaw_impl_a1khly_0(this, action);
      }
      hashCode() {
        return TrimmedString__hashCode_impl_npydux(this.o3m_1);
      }
      equals(other) {
        return TrimmedString__equals_impl_11kln1(this.o3m_1, other);
      }
      d(other) {
        return TrimmedString__compareTo_impl_v1jip4(this, other);
      }
    }
    protoOf($).l3n = compareTo_0;
    initMetadataForClass($, 'TrimmedString', VOID, VOID, [IsRawString()], VOID, VOID, {0: TrimmedStringSerializer_getInstance});
    TrimmedStringClass = $;
  }
  return TrimmedStringClass;
}
function _TrimmedCaselessString___init__impl__li6it1(raw) {
  return raw;
}
function _TrimmedCaselessString___get_raw__impl__ibsfwu($this) {
  return $this;
}
function TrimmedCaselessString__toString_impl_an1uar($this) {
  return _TrimmedCaselessString___get_raw__impl__ibsfwu($this);
}
function TrimmedCaselessString__mapRaw_impl_6pi5jx($this, action) {
  // Inline function 'kotlin.let' call
  // Inline function 'com.lightningkite.trimmedCaseless' call
  // Inline function 'kotlin.text.trim' call
  var this_0 = action(_TrimmedCaselessString___get_raw__impl__ibsfwu($this));
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
  return _TrimmedCaselessString___init__impl__li6it1(tmp$ret$3);
}
function TrimmedCaselessString__mapRaw_impl_6pi5jx_0($this, action) {
  return new (TrimmedCaselessString())(TrimmedCaselessString__mapRaw_impl_6pi5jx($this.s3m_1, action));
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return TrimmedCaselessStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function TrimmedCaselessString__hashCode_impl_we7r3m($this) {
  return getStringHashCode($this);
}
function TrimmedCaselessString__equals_impl_4dmxp2($this, other) {
  if (!(other instanceof TrimmedCaselessString()))
    return false;
  if (!($this === other.s3m_1))
    return false;
  return true;
}
function TrimmedCaselessString__compareTo_impl_or6pv3($this, other) {
  return $this.l3n((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var TrimmedCaselessStringClass;
function TrimmedCaselessString() {
  if (TrimmedCaselessStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.s3m_1 = raw;
      }
      j3n() {
        return _TrimmedCaselessString___get_raw__impl__ibsfwu(this.s3m_1);
      }
      toString() {
        return TrimmedCaselessString__toString_impl_an1uar(this.s3m_1);
      }
      n3n(action) {
        return TrimmedCaselessString__mapRaw_impl_6pi5jx(this.s3m_1, action);
      }
      k3n(action) {
        return TrimmedCaselessString__mapRaw_impl_6pi5jx_0(this, action);
      }
      hashCode() {
        return TrimmedCaselessString__hashCode_impl_we7r3m(this.s3m_1);
      }
      equals(other) {
        return TrimmedCaselessString__equals_impl_4dmxp2(this.s3m_1, other);
      }
      d(other) {
        return TrimmedCaselessString__compareTo_impl_or6pv3(this, other);
      }
    }
    protoOf($).l3n = compareTo_0;
    initMetadataForClass($, 'TrimmedCaselessString', VOID, VOID, [IsRawString()], VOID, VOID, {0: TrimmedCaselessStringSerializer_getInstance});
    TrimmedCaselessStringClass = $;
  }
  return TrimmedCaselessStringClass;
}
function _CaselessString___init__impl__ihury1(raw) {
  return raw;
}
function _CaselessString___get_raw__impl__xzssfw($this) {
  return $this;
}
function CaselessString__toString_impl_halxuh($this) {
  return _CaselessString___get_raw__impl__xzssfw($this);
}
function CaselessString__mapRaw_impl_tnwgd5($this, action) {
  // Inline function 'kotlin.let' call
  // Inline function 'com.lightningkite.caseless' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = action(_CaselessString___get_raw__impl__xzssfw($this)).toLowerCase();
  return _CaselessString___init__impl__ihury1(tmp$ret$2);
}
function CaselessString__mapRaw_impl_tnwgd5_0($this, action) {
  return new (CaselessString())(CaselessString__mapRaw_impl_tnwgd5($this.w3m_1, action));
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      m2a() {
        return CaselessStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function CaselessString__hashCode_impl_vzc7bs($this) {
  return getStringHashCode($this);
}
function CaselessString__equals_impl_ua2id0($this, other) {
  if (!(other instanceof CaselessString()))
    return false;
  if (!($this === other.w3m_1))
    return false;
  return true;
}
function CaselessString__compareTo_impl_hy5lx5($this, other) {
  return $this.l3n((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var CaselessStringClass;
function CaselessString() {
  if (CaselessStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.w3m_1 = raw;
      }
      j3n() {
        return _CaselessString___get_raw__impl__xzssfw(this.w3m_1);
      }
      toString() {
        return CaselessString__toString_impl_halxuh(this.w3m_1);
      }
      o3n(action) {
        return CaselessString__mapRaw_impl_tnwgd5(this.w3m_1, action);
      }
      k3n(action) {
        return CaselessString__mapRaw_impl_tnwgd5_0(this, action);
      }
      hashCode() {
        return CaselessString__hashCode_impl_vzc7bs(this.w3m_1);
      }
      equals(other) {
        return CaselessString__equals_impl_ua2id0(this.w3m_1, other);
      }
      d(other) {
        return CaselessString__compareTo_impl_hy5lx5(this, other);
      }
    }
    protoOf($).l3n = compareTo_0;
    initMetadataForClass($, 'CaselessString', VOID, VOID, [IsRawString()], VOID, VOID, {0: CaselessStringSerializer_getInstance});
    CaselessStringClass = $;
  }
  return CaselessStringClass;
}
function _EmailAddress___init__impl__a6ugvr(raw) {
  return raw;
}
function _EmailAddress___get_raw__impl__6ose2($this) {
  return $this;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        this.i3j_1 = Regex().qh('\\([^)]+\\)');
      }
      m2a() {
        return EmailAddressSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
function EmailAddress__toString_impl_artjh3($this) {
  return _EmailAddress___get_raw__impl__6ose2($this);
}
function _EmailAddress___get_url__impl__h7wdun($this) {
  return 'mailto:' + _EmailAddress___get_raw__impl__6ose2($this);
}
function EmailAddress__mapRaw_impl_xxzlav($this, action) {
  // Inline function 'kotlin.let' call
  var tmp$ret$0 = action(_EmailAddress___get_raw__impl__6ose2($this));
  return toEmailAddress(tmp$ret$0);
}
function EmailAddress__mapRaw_impl_xxzlav_0($this, action) {
  return new (EmailAddress())(EmailAddress__mapRaw_impl_xxzlav($this.c3n_1, action));
}
function EmailAddress__hashCode_impl_wizg9y($this) {
  return getStringHashCode($this);
}
function EmailAddress__equals_impl_pzzdfa($this, other) {
  if (!(other instanceof EmailAddress()))
    return false;
  if (!($this === other.c3n_1))
    return false;
  return true;
}
function EmailAddress__compareTo_impl_sv1ebf($this, other) {
  return $this.l3n((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var EmailAddressClass;
function EmailAddress() {
  if (EmailAddressClass === VOID) {
    class $ {
      constructor(raw) {
        Companion_getInstance_3();
        this.c3n_1 = raw;
      }
      j3n() {
        return _EmailAddress___get_raw__impl__6ose2(this.c3n_1);
      }
      toString() {
        return EmailAddress__toString_impl_artjh3(this.c3n_1);
      }
      p3n(action) {
        return EmailAddress__mapRaw_impl_xxzlav(this.c3n_1, action);
      }
      k3n(action) {
        return EmailAddress__mapRaw_impl_xxzlav_0(this, action);
      }
      hashCode() {
        return EmailAddress__hashCode_impl_wizg9y(this.c3n_1);
      }
      equals(other) {
        return EmailAddress__equals_impl_pzzdfa(this.c3n_1, other);
      }
      d(other) {
        return EmailAddress__compareTo_impl_sv1ebf(this, other);
      }
    }
    protoOf($).l3n = compareTo_0;
    initMetadataForClass($, 'EmailAddress', VOID, VOID, [IsRawString()], VOID, VOID, {0: EmailAddressSerializer_getInstance});
    EmailAddressClass = $;
  }
  return EmailAddressClass;
}
function toEmailAddress(_this__u8e3s4) {
  _init_properties_StringAlts_kt__fevqij();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var fixed = toString(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE())).toLowerCase();
  if (get_emailRegex().rh(fixed))
    return _EmailAddress___init__impl__a6ugvr(fixed);
  else
    throw IllegalArgumentException().a1(fixed + ' is not an email address.');
}
function _PhoneNumber___init__impl__slwhzy(raw) {
  return raw;
}
function _PhoneNumber___get_raw__impl__gc2pmp($this) {
  return $this;
}
function PhoneNumber__toString_impl_7i2x3q($this) {
  return startsWith_0(_PhoneNumber___get_raw__impl__gc2pmp($this), '+1') ? '+1 (' + substring(_PhoneNumber___get_raw__impl__gc2pmp($this), 2, 5) + ') ' + substring(_PhoneNumber___get_raw__impl__gc2pmp($this), 5, 8) + '-' + substring_0(_PhoneNumber___get_raw__impl__gc2pmp($this), 8) : _PhoneNumber___get_raw__impl__gc2pmp($this);
}
function _PhoneNumber___get_url__impl__12igm0($this) {
  return 'tel:' + _PhoneNumber___get_raw__impl__gc2pmp($this);
}
function PhoneNumber__mapRaw_impl_v23amu($this, action) {
  // Inline function 'kotlin.let' call
  var tmp$ret$0 = action(_PhoneNumber___get_raw__impl__gc2pmp($this));
  return toPhoneNumber(tmp$ret$0);
}
function PhoneNumber__mapRaw_impl_v23amu_0($this, action) {
  return new (PhoneNumber())(PhoneNumber__mapRaw_impl_v23amu($this.h3n_1, action));
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      m2a() {
        return PhoneNumberSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function PhoneNumber__hashCode_impl_t98twl($this) {
  return getStringHashCode($this);
}
function PhoneNumber__equals_impl_svvo3b($this, other) {
  if (!(other instanceof PhoneNumber()))
    return false;
  if (!($this === other.h3n_1))
    return false;
  return true;
}
function PhoneNumber__compareTo_impl_1hrt7o($this, other) {
  return $this.l3n((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var PhoneNumberClass;
function PhoneNumber() {
  if (PhoneNumberClass === VOID) {
    class $ {
      constructor(raw) {
        this.h3n_1 = raw;
      }
      j3n() {
        return _PhoneNumber___get_raw__impl__gc2pmp(this.h3n_1);
      }
      toString() {
        return PhoneNumber__toString_impl_7i2x3q(this.h3n_1);
      }
      q3n(action) {
        return PhoneNumber__mapRaw_impl_v23amu(this.h3n_1, action);
      }
      k3n(action) {
        return PhoneNumber__mapRaw_impl_v23amu_0(this, action);
      }
      hashCode() {
        return PhoneNumber__hashCode_impl_t98twl(this.h3n_1);
      }
      equals(other) {
        return PhoneNumber__equals_impl_svvo3b(this.h3n_1, other);
      }
      d(other) {
        return PhoneNumber__compareTo_impl_1hrt7o(this, other);
      }
    }
    protoOf($).l3n = compareTo_0;
    initMetadataForClass($, 'PhoneNumber', VOID, VOID, [IsRawString()], VOID, VOID, {0: PhoneNumberSerializer_getInstance});
    PhoneNumberClass = $;
  }
  return PhoneNumberClass;
}
function toPhoneNumber(_this__u8e3s4) {
  _init_properties_StringAlts_kt__fevqij();
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.text.filter' call
  var tmp0 = _this__u8e3s4.toLowerCase();
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().d1();
  var inductionVariable = 0;
  var last = charSequenceLength(tmp0);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(tmp0, index);
      if (!get_punctuation().t1(new (Char())(element))) {
        destination.xb(element);
      }
    }
     while (inductionVariable < last);
  var fixed = destination.toString();
  if (startsWith(fixed, _Char___init__impl__6a9atx(43))) {
    return _PhoneNumber___init__impl__slwhzy(fixed);
  } else if (fixed.length === 10) {
    return _PhoneNumber___init__impl__slwhzy('+1' + fixed);
  } else {
    throw IllegalArgumentException().a1("Phone numbers should begin with a '+' and your country code.");
  }
}
var properties_initialized_StringAlts_kt_xpptoj;
function _init_properties_StringAlts_kt__fevqij() {
  if (!properties_initialized_StringAlts_kt_xpptoj) {
    properties_initialized_StringAlts_kt_xpptoj = true;
    emailRegex = Regex().qh('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])');
    punctuation = setOf([new (Char())(_Char___init__impl__6a9atx(32)), new (Char())(_Char___init__impl__6a9atx(45)), new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(44)), new (Char())(_Char___init__impl__6a9atx(40)), new (Char())(_Char___init__impl__6a9atx(41)), new (Char())(_Char___init__impl__6a9atx(91)), new (Char())(_Char___init__impl__6a9atx(93)), new (Char())(_Char___init__impl__6a9atx(60)), new (Char())(_Char___init__impl__6a9atx(62))]);
  }
}
//region block: init
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_4 = new (Companion_4())();
//endregion
//region block: exports
export {
  EmailAddress as EmailAddress1n0o8cqqfp9qz,
  IsRawString as IsRawStringxv018dzbtx4q,
  PhoneNumber as PhoneNumber2x98iurnwvnj9,
  toEmailAddress as toEmailAddress2ffkb20dbp5nk,
  toPhoneNumber as toPhoneNumber24bmj59aego07,
  _EmailAddress___init__impl__a6ugvr as _EmailAddress___init__impl__a6ugvr3vyholn0wwoi2,
  EmailAddress__hashCode_impl_wizg9y as EmailAddress__hashCode_impl_wizg9y17d6wnfa2ztdr,
  _EmailAddress___get_raw__impl__6ose2 as _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10,
  EmailAddress__toString_impl_artjh3 as EmailAddress__toString_impl_artjh32mgb4pan49acs,
  _EmailAddress___get_url__impl__h7wdun as _EmailAddress___get_url__impl__h7wdun3iqx1gt6bapgk,
  _PhoneNumber___init__impl__slwhzy as _PhoneNumber___init__impl__slwhzyo93bblbw66x0,
  PhoneNumber__hashCode_impl_t98twl as PhoneNumber__hashCode_impl_t98twl1f2h2fisb0rc2,
  _PhoneNumber___get_raw__impl__gc2pmp as _PhoneNumber___get_raw__impl__gc2pmp2lry17e31ba5a,
  PhoneNumber__toString_impl_7i2x3q as PhoneNumber__toString_impl_7i2x3q276u0h00tg72g,
  _PhoneNumber___get_url__impl__12igm0 as _PhoneNumber___get_url__impl__12igm036eb90tuqn2ei,
  Companion_instance_2 as Companion_instance2lv9vrt1es5f2,
  CaselessStringSerializer_getInstance as CaselessStringSerializer_getInstance1rdo0fmpuy1jg,
  Companion_getInstance_3 as Companion_getInstancesldiilhozd0o,
  EmailAddressSerializer_getInstance as EmailAddressSerializer_getInstanceu3ltgmcd8ai,
  Companion_getInstance as Companion_getInstancejecdfbtr9cdw,
  LowercaseOnSerialize_getInstance as LowercaseOnSerialize_getInstance11cfqc8x5j84m,
  Companion_instance_4 as Companion_instance2lqekn5oedduv,
  PhoneNumberSerializer_getInstance as PhoneNumberSerializer_getInstance2oi38jtxahgwm,
  TrimLowercaseOnSerialize_getInstance as TrimLowercaseOnSerialize_getInstancepdso2ahq8pnj,
  TrimOnSerialize_getInstance as TrimOnSerialize_getInstancep6w4pxtjrig1,
  Companion_instance_1 as Companion_instancep5538yw9sfln,
  TrimmedCaselessStringSerializer_getInstance as TrimmedCaselessStringSerializer_getInstanceyb3lxczh7nmz,
  Companion_instance_0 as Companion_instance20zkfeibsiypi,
  TrimmedStringSerializer_getInstance as TrimmedStringSerializer_getInstance27ofsorf7atqs,
};
//endregion

//# sourceMappingURL=StringAlts.mjs.map
